import classNames from 'classnames';
import { upperFirst } from 'lodash';
import { mergeStyles } from 'wix-rich-content-common';
import { s as styleInject } from './style-inject.es-746bb8ed.js';
import { S as Styles } from './default-styles-74c82233.js';

var css_248z = ".-prsX{display:flex;justify-content:left}.JjscW{display:flex;justify-content:right}.-SsHD{display:flex!important;justify-content:center}";
var alignmentStyles = {"button_align_left":"-prsX","button_align_right":"JjscW","button_align_center":"-SsHD"};
styleInject(css_248z);

const alignmentClassName = (componentData, theme, styles2) => {
  const { alignment = "center" } = componentData.config || {};
  const mergedStyles = mergeStyles({ styles: alignmentStyles, theme });
  return classNames(
    mergedStyles[`button_align_${alignment}`],
    styles2[`align${upperFirst(alignment)}`],
    theme[`align${upperFirst(alignment)}`]
  );
};
const sizeClassName = (componentData, theme) => {
  const mergedStyles = mergeStyles({ styles: Styles, theme });
  return mergedStyles.button_size_content;
};

export { alignmentClassName, sizeClassName };
//# sourceMappingURL=classNameStrategies.js.map
